import { useSelector } from 'react-redux';
import { isAiAssistantAllowed } from 'constants/aiAccess';

/**
 * True only when the logged-in user's email is on the AI assistant allow list
 * in `constants/aiAccess`. Used to hide every AI entry point (ChatBubble,
 * dashboard briefing strip) from everyone else.
 */
const useAiAssistantAccess = (): boolean => {
	const email = useSelector((state: any) => state?.userProfile?.data?.email);
	return isAiAssistantAllowed(email);
};

export default useAiAssistantAccess;
